<template>
  <div class="content">
    <a-row :gutter="16">
      <a-col :span="8">
        <a-row>
          <a-col>
            <div class="canv-content">
              <dv-border-box-1
                ><div>
                  <span class="title"> 生活区周交易热度 </span>
                </div>
                <dv-capsule-chart
                  :config="addressInfo"
                  style="width: 100%; height: 300px"
                />
              </dv-border-box-1>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col
            ><div class="canv-content">
              <dv-border-box-11 title="明日各食堂单量预估分析"
                ><div>
                  <span class="title"> </span>
                </div>
                <dv-active-ring-chart
                  :config="order"
                  style="width: 100%; height: 100%"
                />
              </dv-border-box-11>
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="8">
        <a-row>
          <a-col>
            <div class="date">{{ date }}</div>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <div class="total">
              <span class="total-money"
                ><span class="total-money-title">总交易额：</span>￥{{
                  totalMoney / 100
                }}</span
              >
            </div>
            <div class="total">
              <div class="total-item">
                <a-row>
                  <a-col span="12">
                    <span class="total-item-title">总交易笔数：</span>
                    {{ totalOrderNumber }}
                  </a-col>
                  <a-col span="12"
                    ><span class="total-item-title">总交易人数：</span
                    >{{ totalUser }}</a-col
                  >
                </a-row>
              </div>
              <div class="total-item">
                <a-row>
                  <a-col span="12">
                    <span class="total-item-title">今日订单量：</span
                    >{{ todayNumber }}
                  </a-col>
                  <a-col span="12"
                    ><span class="total-item-title">今日交易额：</span>￥{{
                      todayMoney / 100
                    }}</a-col
                  >
                </a-row>
              </div>
              <div class="total-item">
                <a-row>
                  <a-col span="12">
                    <span class="total-item-title">总用户量：</span
                    >{{ totalUserNumber }}
                  </a-col>
                  <a-col span="12"
                    ><span class="total-item-title">今日新增用户：</span
                    >{{ todayUserNumber }}</a-col
                  >
                </a-row>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-divider />
        <div class="eva-title">
          <span class="title"> 评价反馈 </span>
        </div>
        <div class="eva" v-for="(item, index) in showEvaluation" :key="index">
          <a-row type="flex">
            <a-col>
              <span class="eva-item eva-name">{{
                truncateText(item.user.nickname)
              }}</span>
            </a-col>
          </a-row>
          <a-row type="flex">
            <a-col
              ><span class="eva-item eva-content"
                >{{ item.evaluation_content }}
              </span></a-col
            >
          </a-row>
        </div>
      </a-col>
      <a-col :span="8">
        <a-row>
          <a-col>
            <div class="right-content">
              <dv-border-box-11 title="外卖自提比例"
                ><dv-active-ring-chart
                  :config="type"
                  style="width: 100%; height: 300px"
              /></dv-border-box-11>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <div class="right-content">
              <dv-border-box-13
                ><div>
                  <span class="title"> 食堂销量排名 </span>
                </div>
                <dv-capsule-chart
                  :config="shop"
                  style="width: 100%; height: 200px"
              /></dv-border-box-13>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <div class="right-content">
              <dv-border-box-10
                ><div>
                  <span class="title"> 美食周销量排名 </span>
                </div>
                <dv-capsule-chart
                  :config="foods"
                  style="width: 100%; height: 200px"
              /></dv-border-box-10>
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",

  data() {
    return {
      isRefreshing: false,
      dataTimer: null,
      timer: null,
      eva: null,
      totalOrderNumber: 0,
      totalUser: 0,
      totalMoney: 0,
      shop: {
        data: [],
      },
      type: {
        data: [],
        showOriginValue: true,
      },
      user: {
        data: [],
        showOriginValue: true,
      },
      foods: {
        data: [],
      },
      addressInfo: {
        data: [],
      },
      order: {
        data: [],
        digitalFlopStyle: {
          fontSize: 15,
        },
        showOriginValue: true,
      },
      date: new Date(),
      todayNumber: 0,
      todayMoney: 0,
      totalUserNumber: 0,
      todayUserNumber: 0,
      evaluationArr: [],
      showEvaluation: [],
    };
  },
  async mounted() {
    this.timer = setInterval(() => {
      this.date = new Date();
    }, 1000);

    await this.loadDashboardData();

    this.eva = setInterval(() => {
      this.rotateEvaluation();
    }, 3000);

    this.dataTimer = setInterval(() => {
      this.loadDashboardData({ withEvaluation: false });
    }, 15000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
    if (this.eva) {
      clearInterval(this.eva);
    }
    if (this.dataTimer) {
      clearInterval(this.dataTimer);
    }
  },
  methods: {
    getRandom(start, end, fixed = 0) {
      let differ = end - start;
      let random = Math.random();
      return Number((start + differ * random).toFixed(fixed));
    },
    truncateText(text, maxLength = 8) {
      if (!text) {
        return "";
      }
      return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    },
    rotateEvaluation() {
      if (!this.evaluationArr.length) {
        this.showEvaluation = [];
        return;
      }

      if (this.showEvaluation.length < 5) {
        this.showEvaluation = this.evaluationArr
          .slice(0, 5)
          .map((item) => item || {});
        return;
      }

      const index = this.getRandom(0, this.evaluationArr.length - 1);
      const nextItem = this.evaluationArr[index];

      if (!nextItem) {
        return;
      }

      this.showEvaluation = [...this.showEvaluation.slice(1), nextItem];
    },
    async loadDashboardData({ withEvaluation = true } = {}) {
      if (this.isRefreshing) {
        return;
      }

      this.isRefreshing = true;

      try {
        const tasks = [
          ["getUser", this.getManAndWoman()],
          ["getShopOrder", this.getShopOrder()],
          ["getTodayOrder", this.getTodayOrder()],
          ["getAddress", this.getAddress()],
          ["getFoods", this.getFoods()],
          ["today", this.today()],
          ["userCount", this.userCount()],
          ["getTotalOrder", this.getTotalOrder()],
          ["getTotalUser", this.getTotalUser()],
          ["getTotalMoney", this.getTotalMoney()],
          ["getDeliveryType", this.getSendAndSelf()],
          ...(withEvaluation ? [["evaluation", this.evaluation()]] : []),
        ];
        const results = await Promise.allSettled(tasks.map(([, task]) => task));

        results.forEach((result, index) => {
          if (result.status === "rejected") {
            const requestUrl = result.reason && result.reason.requestUrl;
            console.error(
              `Dashboard request failed: ${tasks[index][0]}`,
              requestUrl || result.reason
            );
          }
        });
      } finally {
        this.isRefreshing = false;
      }
    },
    async evaluation() {
      const res = await this.$api.evaluation();
      this.evaluationArr = Array.isArray(res.data) ? res.data : [];
      this.showEvaluation = this.evaluationArr.slice(0, 6);
    },
    async userCount() {
      const res = await this.$api.userCount();
      this.totalUserNumber = res.data.total;
      this.todayUserNumber = res.data.today;
    },
    async today() {
      const res = await this.$api.today();
      this.todayNumber = res.data.number;
      this.todayMoney = res.data.money;
    },
    async getFoods() {
      const res = await this.$api.getFoods();
      const data = Array.isArray(res.data) ? res.data : [];
      this.foods.data = data.map((e) => ({
          name: this.truncateText(e.goods_name),
          value: e.number,
        }));
      this.foods = { ...this.foods };
    },
    async getAddress() {
      const res = await this.$api.getAddress();
      const data = Array.isArray(res.data) ? res.data : [];
      this.addressInfo.data = data.map((e) => ({
          name: this.truncateText(e.address_name, 5),
          value: e.number,
        }));
      this.addressInfo = { ...this.addressInfo };
    },
    async getTodayOrder() {
      const res = await this.$api.getTodayOrder();
      const data = Array.isArray(res.data) ? res.data : [];
      this.order.data = data.map((e) => ({
          value: e.value,
          name: this.truncateText(e.name),
        }));
      this.order = { ...this.order };
    },

    async getShopOrder() {
      const res = await this.$api.getShopOrder();
      const data = Array.isArray(res.data) ? res.data : [];
      this.shop.data = data.map((e) => ({
          name: this.truncateText(e.name),
          value: e.order_count,
        }));
      this.shop = { ...this.shop };
    },
    async getSendAndSelf() {
      const res = await this.$api.getDeliveryType();
      this.type.data = [
        {
          name: "外卖",
          value: res.data.delivery,
        },
        {
          name: "自提",
          value: res.data.self,
        },
      ];
      this.type = { ...this.type };
    },
    async getManAndWoman() {
      const res = await this.$api.getUser();
      this.user.data = [
        {
          name: "男",
          value: res.data.man,
        },
        {
          name: "女",
          value: res.data.woman,
        },
      ];
      this.user = { ...this.user };
    },
    async getTotalOrder() {
      const res = await this.$api.getTotalOrder();
      this.totalOrderNumber = res.data;
    },
    async getTotalUser() {
      const res = await this.$api.getTotalUser();
      this.totalUser = res.data;
    },
    async getTotalMoney() {
      const res = await this.$api.getTotalMoney();
      this.totalMoney = res.data;
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 100%;
  min-height: 100vh;
  padding: 10px 12px;
  box-sizing: border-box;
  overflow-x: hidden;
  background-image: linear-gradient(
      rgba(14, 32, 74, 0.72),
      rgba(14, 32, 74, 0.72)
    ),
    url("https://iaec.xmu.edu.cn/images/26/03/27/7ilfraunp8/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260327093241_64_707.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .eva-title {
    margin-top: 8px;
    padding: 0;
  }
  .eva {
    margin-top: 8px;
    padding: 6px 0;
  }
  .title {
    font-size: clamp(20px, 1.5vw, 28px);
    line-height: 1.2;
    color: #fff;
  }
  .eva-item {
    display: block;
    width: 100%;
    font-size: 14px;
    line-height: 1.5;
    color: #fff;
    text-align: left;
    word-break: break-all;
  }
  .eva-name {
    margin-bottom: 4px;
  }
  .eva-content {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .avatar {
    width: 50px;
    border-radius: 10px;
  }
  .canv-content {
    box-sizing: border-box;
    height: calc((100vh - 70px) / 2);
    min-height: 280px;
    margin: 10px 0;
    overflow: hidden;
    .title {
      font-size: clamp(20px, 1.5vw, 28px);
      color: #fff;
    }
  }
  .date {
    padding: 0;
    font-size: clamp(16px, 1.2vw, 20px);
    color: #fff;
    text-align: center;
  }
  .total {
    padding: 6px 0;
    &-money {
      font-size: clamp(40px, 3.2vw, 56px);
      line-height: 1.2;
      color: #deb664;
      &-title {
        font-size: clamp(24px, 2vw, 32px);
        color: #fff;
      }
    }
    &-item {
      padding: 12px 0;
      font-size: clamp(16px, 1.4vw, 22px);
      color: #deb664;
      &-title {
        font-size: inherit;
        color: #fff;
      }
    }
  }
  .shop {
    margin-top: 90px;
  }
  .right {
    &-content {
      box-sizing: border-box;
      height: calc((100vh - 90px) / 3);
      min-height: 200px;
      margin: 10px 0;
      overflow: hidden;
      .title {
        font-size: clamp(20px, 1.5vw, 28px);
        color: #fff;
      }
    }
  }
  ::v-deep .border-box-content,
  ::v-deep .dv-border-box-content {
    width: 100% !important;
    height: 100% !important;
    overflow: hidden;
    box-sizing: border-box;
  }
  ::v-deep canvas,
  ::v-deep svg {
    max-width: 100% !important;
    max-height: 100% !important;
  }
}
</style>
